import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// store state in localStorage to persist it through sessions
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    settings: {
      backgroundClass: 'bg-default' // default bg-class
    },
    locale: {
      language: 'de' // default value
    },
    gdpr: {
        accepted: false
    }
  },
  mutations: {
    acceptGdpr(state) {
        state.gdpr.accepted = true
    },
    setLocaleLanguage(state, lang) {
      state.locale.language = lang
    },
    setBackgroundClass(state, className) {
      state.settings.backgroundClass = className
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
